// @flow
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { getBaseUrl } from '../../../redux/modules/config';
import { getMobileBrowserOS } from '../../../redux/modules/browser';
import { getWhiteLabelName } from '../../../redux/modules/whiteLabel';
import { getWindowSize } from '../../../redux/modules/windowSize';
import WhiteLabelFooter from './WhiteLabelFooter';

const mapStateToProps = state => {
    const { width: windowWidth } = getWindowSize(state);

    return {
        baseUrl: getBaseUrl(state),
        mobileBrowserOS: getMobileBrowserOS(state),
        whiteLabelName: getWhiteLabelName(state),
        windowWidth,
        year: new Date().getFullYear(),
    };
};

type Props = {
    baseUrl: string,
    mobileBrowserOS: string,
    whiteLabelName: string,
    windowWidth: number,
    year: number,
};

class WhiteLabelFooterContainer extends PureComponent<Props> {
    render() {
        const { baseUrl, mobileBrowserOS, whiteLabelName, windowWidth, year } = this.props;

        return (
            <WhiteLabelFooter
                baseUrl={baseUrl}
                mobileBrowserOS={mobileBrowserOS}
                whiteLabelName={whiteLabelName}
                windowWidth={windowWidth}
                year={year}
            />
        );
    }
}

export default connect(mapStateToProps)(WhiteLabelFooterContainer);
